/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const ContactsFilterIcon = ({
  className,
  style,
  color = '#DBD7E6',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M36 37C34.346 37 33 35.654 33 34C33 32.346 34.346 31 36 31C37.654 31 39 32.346 39 34C39 35.654 37.654 37 36 37Z"
        fill={color}
      />
      <path
        d="M44 37C42.346 37 41 35.654 41 34C41 32.346 42.346 31 44 31C45.654 31 47 32.346 47 34C47 35.654 45.654 37 44 37Z"
        fill={color}
      />
      <path
        d="M28 37C26.346 37 25 35.654 25 34C25 32.346 26.346 31 28 31C29.654 31 31 32.346 31 34C31 35.654 29.654 37 28 37Z"
        fill={color}
      />
      <path
        d="M20 37C18.346 37 17 35.654 17 34C17 32.346 18.346 31 20 31C21.654 31 23 32.346 23 34C23 35.654 21.654 37 20 37Z"
        fill={color}
      />
      <path d="M27 59H21V53H27V59Z" fill={color} />
      <path d="M59 59H53V53H59V59Z" fill={color} />
      <path
        d="M60 27C61.654 27 63 25.654 63 24V22C63 20.346 61.654 19 60 19H57V18C57 14.232 54.67 11.002 51.377 9.663C52.368 8.749 53 7.451 53 6C53 3.243 50.757 1 48 1C45.243 1 43 3.243 43 6C43 7.451 43.632 8.749 44.623 9.663C42.623 10.476 40.982 11.988 40 13.895C39.017 11.988 37.377 10.476 35.377 9.663C36.368 8.749 37 7.451 37 6C37 3.243 34.757 1 32 1C29.243 1 27 3.243 27 6C27 7.451 27.632 8.749 28.623 9.663C26.623 10.476 24.982 11.988 24 13.895C23.017 11.988 21.377 10.476 19.377 9.663C20.368 8.749 21 7.451 21 6C21 3.243 18.757 1 16 1C13.243 1 11 3.243 11 6C11 7.451 11.632 8.749 12.623 9.663C9.33 11.002 7 14.232 7 18V19H4C2.346 19 1 20.346 1 22V24C1 25.654 2.346 27 4 27H5.474L15.099 41H4C2.346 41 1 42.346 1 44V60C1 61.654 2.346 63 4 63H28C29.654 63 31 61.654 31 60V59H33V60C33 61.654 34.346 63 36 63H60C61.654 63 63 61.654 63 60V44C63 42.346 61.654 41 60 41H48.901L58.526 27H60ZM45 6C45 4.346 46.346 3 48 3C49.654 3 51 4.346 51 6C51 7.654 49.654 9 48 9C46.346 9 45 7.654 45 6ZM48 11C51.859 11 55 14.14 55 18V19H41V18C41 14.14 44.141 11 48 11ZM29 6C29 4.346 30.346 3 32 3C33.654 3 35 4.346 35 6C35 7.654 33.654 9 32 9C30.346 9 29 7.654 29 6ZM32 11C35.859 11 39 14.14 39 18V19H25V18C25 14.14 28.141 11 32 11ZM13 6C13 4.346 14.346 3 16 3C17.654 3 19 4.346 19 6C19 7.654 17.654 9 16 9C14.346 9 13 7.654 13 6ZM9 18C9 14.14 12.141 11 16 11C19.859 11 23 14.14 23 18V19H9V18ZM3 24V22C3 21.449 3.448 21 4 21H60C60.552 21 61 21.449 61 22V24C61 24.551 60.552 25 60 25H4C3.448 25 3 24.551 3 24ZM10 50C10 48.346 11.346 47 13 47C14.654 47 16 48.346 16 50C16 51.654 14.654 53 13 53C11.346 53 10 51.654 10 50ZM7 61C7 57.691 9.691 55 13 55C16.309 55 19 57.691 19 61H7ZM29 60C29 60.551 28.552 61 28 61H21C21 57.768 19.07 54.984 16.305 53.723C17.336 52.806 18 51.485 18 50C18 47.243 15.757 45 13 45C10.243 45 8 47.243 8 50C8 51.485 8.664 52.806 9.695 53.723C6.93 54.984 5 57.768 5 61H4C3.448 61 3 60.551 3 60V44C3 43.449 3.448 43 4 43H28C28.552 43 29 43.449 29 44V60ZM42 50C42 48.346 43.346 47 45 47C46.654 47 48 48.346 48 50C48 51.654 46.654 53 45 53C43.346 53 42 51.654 42 50ZM39 61C39 57.691 41.691 55 45 55C48.309 55 51 57.691 51 61H39ZM61 44V60C61 60.551 60.552 61 60 61H53C53 57.768 51.07 54.984 48.305 53.723C49.336 52.806 50 51.485 50 50C50 47.243 47.757 45 45 45C42.243 45 40 47.243 40 50C40 51.485 40.664 52.806 41.695 53.723C38.93 54.984 37 57.768 37 61H36C35.448 61 35 60.551 35 60V44C35 43.449 35.448 43 36 43H60C60.552 43 61 43.449 61 44ZM46.474 41H36C34.346 41 33 42.346 33 44V57H31V44C31 42.346 29.654 41 28 41H17.526L7.901 27H56.099L46.474 41Z"
        fill={color}
      />
      <path d="M20 45H27V47H20V45Z" fill={color} />
      <path d="M20 49H27V51H20V49Z" fill={color} />
      <path d="M52 49H59V51H52V49Z" fill={color} />
    </svg>
  );
};
